import script from "./TNotifications.vue?vue&type=script&setup=true&lang=ts"
export * from "./TNotifications.vue?vue&type=script&setup=true&lang=ts"

import "./TNotifications.vue?vue&type=style&index=0&id=92bf462c&lang=scss"

const __exports__ = script;

export default __exports__